import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import TagBadge from './TagBadge';

export default function TagPicker({ value = [], onChange, allTags: providedTags }) {
  const { api } = useAuth();
  const [allTags, setAllTags] = useState(providedTags || []);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    if (providedTags) { setAllTags(providedTags); return; }
    api('/tags').then(setAllTags).catch(() => {});
  }, [providedTags]);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  const selectedIds = new Set(value);
  const selectedTags = allTags.filter(t => selectedIds.has(t.id));
  const filtered = allTags.filter(t =>
    !selectedIds.has(t.id) &&
    (!search || t.name.toLowerCase().includes(search.toLowerCase()))
  );

  const toggle = (tag) => {
    if (selectedIds.has(tag.id)) {
      onChange(value.filter(id => id !== tag.id));
    } else {
      onChange([...value, tag.id]);
    }
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4,
          minHeight: 38, padding: '6px 10px',
          border: '1px solid var(--border, var(--border-strong))', borderRadius: 6,
          background: 'var(--surface, #fff)', cursor: 'pointer',
        }}
      >
        {selectedTags.length > 0 ? selectedTags.map(t => (
          <TagBadge key={t.id} tag={t} onRemove={() => toggle(t)} />
        )) : (
          <span style={{ color: 'var(--text-muted, var(--text-faint))', fontSize: 13 }}>اختر وسوماً...</span>
        )}
      </div>
      {open && (
        <div style={{
          position: 'absolute', zIndex: 50, top: '100%', insetInlineStart: 0, insetInlineEnd: 0, marginTop: 4,
          background: 'var(--surface, #fff)', border: '1px solid var(--border, var(--border-strong))',
          borderRadius: 6, boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
          maxHeight: 240, overflowY: 'auto', padding: 6,
        }}>
          <input
            autoFocus
            className="form-input"
            placeholder="🔍 بحث..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ marginBottom: 6, fontSize: 13 }}
          />
          {filtered.length === 0 ? (
            <div style={{ padding: 8, color: 'var(--text-muted, var(--text-faint))', fontSize: 12 }}>
              {allTags.length === 0 ? 'لا توجد وسوم — أنشئها من إدارة الوسوم' : 'لا توجد نتائج'}
            </div>
          ) : filtered.map(t => (
            <div
              key={t.id}
              onClick={() => toggle(t)}
              style={{ padding: '6px 8px', cursor: 'pointer', borderRadius: 4, display: 'flex', alignItems: 'center', gap: 8 }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--gray-100, var(--surface-alt))'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <TagBadge tag={t} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
